'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useSession } from '@clerk/nextjs';
import { setClerkSession } from '../clerk-session-bridge';
import { useClerkVisibilityRefresh } from '../hooks/use-clerk-visibility-refresh';

/**
 * Mounts once near `ClerkProvider`. Subscribes to `useSession()` and writes
 * the active session into the module-level bridge so the TanStack cache
 * handlers (running outside React) can call `session.getToken({ skipCache })`
 * on a 401. Re-mints the JWT on `visibilitychange` so a background-throttled
 * stale token never lands a 401 on the user's first post-return navigation.
 *
 * Renders nothing.
 */
export function ClerkSessionBridge() {
  const $ = _c(3);
  const {
    session
  } = useSession();
  let t0;
  let t1;
  if ($[0] !== session) {
    t0 = () => {
      setClerkSession(session ?? null);
    };
    t1 = [session];
    $[0] = session;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  useClerkVisibilityRefresh();
  return null;
}